import { Box, PrimaryPaper } from '@atoms/layout';
import { FormattedMessage, useIntl } from 'react-intl';
import { Stack } from '@mui/material';
import { DataGrid } from '@molecules/dataDisplay';
import { EmptyListPlaceholder } from '@molecules/dataDisplay';
import { ShiftsIcon } from '@atoms/icons';
import { useRequestsListColumns } from '../columns';
import { ClientRequestsFilters } from './filters';
import { useClientRequestsListFiltersStore, useClientRequestsListStore } from '@libs/store/clientRequests';
import { useRefreshSyncStore } from '@libs/store/refreshSync';
import { useEffect } from 'react';
import { DEFAULT_PAGE_SIZE, PAGE_SIZE_OPTIONS } from '@molecules/dataDisplay/dataGrid';

type Props = {
  localizationSubset: string;
};

export function RequestsListPage({ localizationSubset }: Props) {
  const intl = useIntl();
  const { page, perPage, total, requests, loadRequests, loadingList } = useClientRequestsListStore();
  const { refreshTrigger } = useRefreshSyncStore();
  const { activeFilters } = useClientRequestsListFiltersStore();
  const loading = loadingList;

  useEffect(() => {
    loadRequests(activeFilters, 1, DEFAULT_PAGE_SIZE);
  }, [loadRequests, refreshTrigger, activeFilters]);

  return (
    <Box aria-label="ClientsRequestsSubpage" sx={{ height: '100%', width: '100%' }}>
      <PrimaryPaper sx={{ height: '100%', minHeight: 0, mt: 2 }}>
        <Stack spacing={2} sx={{ height: '100%', width: '100%' }}>
          <ClientRequestsFilters loading={loading} localizationSubset={localizationSubset} />{' '}
          <DataGrid
            rows={requests}
            loading={loading}
            rowHeight={64}
            columns={useRequestsListColumns(localizationSubset)}
            hideFooter
            disableRowSelectionOnClick
            noRowsOverlay={
              <EmptyListPlaceholder
                icon={<ShiftsIcon active />}
                title={<FormattedMessage id={`${localizationSubset}.table.noRows.title`} />}
                subtitle={<FormattedMessage id={`${localizationSubset}.table.noRows.subtitle`} />}
              />
            }
            initialState={{
              pagination: {
                paginationModel: {
                  pageSize: DEFAULT_PAGE_SIZE,
                },
              },
            }}
            onPaginationModelChange={(params) => {
              loadRequests(activeFilters, params.page, params.pageSize);
            }}
            paginationModel={{
              pageSize: perPage,
              page: page,
            }}
            rowCount={total}
            pageSizeOptions={PAGE_SIZE_OPTIONS}
          />
        </Stack>
      </PrimaryPaper>
    </Box>
  );
}
